import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./axios";
import i18n from "./i18n";

import moment from "moment";
Vue.prototype.moment = moment;

// Buefy + Icons
import Buefy from "buefy";
// import 'buefy/dist/buefy.css'
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEye,
  faEyeSlash,
  faPlusCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faCheck,
  faCheckCircle,
  faArrowAltCircleLeft,
  faTimesCircle,
  faSave,
  faAngleDown,
  faSyncAlt,
  faArrowUp,
  faComments,
  faInfoCircle,
  faCog,
  faExternalLinkSquareAlt,
  faAngleLeft,
  faAngleRight,
  faCaretDown,
  faCaretUp,
  faMinusCircle,
  faFrown,
  faSearch,
  faSort,
  faStore,
  faExchangeAlt,
  faBox,
  faDoorOpen,
  faShoppingCart,
  faCreditCard,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faUserCog,
  faEnvelope,
  faSignOutAlt,
  faCoins,
  faTag,
  faPercentage,
  faWallet,
  faHandHoldingUsd,
  faFileInvoice,
  faCalendarAlt,
  faDownload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faEye,
  faEyeSlash,
  faPlusCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faCheck,
  faCheckCircle,
  faArrowAltCircleLeft,
  faTimesCircle,
  faSave,
  faAngleDown,
  faSyncAlt,
  faArrowUp,
  faComments,
  faInfoCircle,
  faCog,
  faExternalLinkSquareAlt,
  faAngleLeft,
  faAngleRight,
  faCaretDown,
  faCaretUp,
  faMinusCircle,
  faFrown,
  faSearch,
  faSort,
  faStore,
  faExchangeAlt,
  faBox,
  faDoorOpen,
  faShoppingCart,
  faCreditCard,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faUserCog,
  faEnvelope,
  faSignOutAlt,
  faCoins,
  faTag,
  faPercentage,
  faWallet,
  faHandHoldingUsd,
  faFileInvoice,
  faCalendarAlt,
  faDownload
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Buefy, {
  defaultIconComponent: "font-awesome-icon",
  defaultIconPack: "fas"
});

// Other Vue Config
Vue.prototype.$http = http;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
